import { type Ref } from "vue";

export function pushConsentBarShow() {
    dataLayer.push({
        event: "action.impress.promos",
        action: {
            impress: {
                promos: [
                    {
                        id: "cookieDisclaimer",
                        name: "cookieDisclaimer",
                        position: "bottom",
                    },
                ],
            },
        },
    });
}

export function pushEssentialsConsentBar() {
    dataLayer.push({
        event: "action.show.promos",
        action: {
            show: {
                promos: [
                    {
                        id: "cookieDisclaimer.essentials",
                        name: "cookieDisclaimer",
                        position: "bottom",
                    },
                ],
            },
        },
    });
}

export function pushAllConsentBar() {
    dataLayer.push({
        event: "action.show.promos",
        action: {
            show: {
                promos: [
                    {
                        id: "cookieDisclaimer",
                        name: "cookieDisclaimer",
                        position: "bottom",
                    },
                ],
            },
        },
    });
}

export function useWecomaDatalayer(cookieBarMode?: Ref, cookieBarModeExpiration?: Ref) {
    // DL1.10
    const pushViewCookieBarInitial = (isLogged: boolean) => {
        dataLayer.push({
            event: "action.view.cmp",
            action: {
                view: {
                    cmp: {
                        location: "init." + (isLogged ? "logged" : "anonymous"),
                        stage: "initial",
                    },
                },
            },
        });
    };

    // DL1.10
    const pushViewCookieBarRecheckAll = (isLogged: boolean) => {
        dataLayer.push({
            event: "action.view.cmp",
            action: {
                view: {
                    cmp: {
                        location: "init." + (isLogged ? "logged" : "anonymous"),
                        stage: cookieBarMode.value,
                        expirationDays: cookieBarModeExpiration.value,
                    },
                },
            },
        });
    };

    // DL1.10
    const pushViewCookieBarRecheckSome = (isLogged: boolean) => {
        dataLayer.push({
            event: "action.view.cmp",
            action: {
                view: {
                    cmp: [
                        {
                            location: "init." + (isLogged ? "logged" : "anonymous"),
                            stage: cookieBarMode.value,
                            expirationDays: cookieBarModeExpiration.value,
                        },
                    ],
                },
            },
        });
    };

    // DL1.20
    const pushAllPurposesConsentClick = (purposeCodes: string, isLogged: boolean) => {
        dataLayer.push({
            event: "action.grantConsent.cmp",
            action: {
                grantConsent: {
                    cmp: {
                        location: "init." + (isLogged ? "logged" : "anonymous"),
                        stage: cookieBarMode.value,
                        expirationDays: cookieBarModeExpiration.value,
                        purposeCodes,
                    },
                },
            },
        });
    };

    // DL1.30
    const pushRedirectToPreferenceCenter = (variant: string, isLogged: boolean) => {
        dataLayer.push({
            event: "action.openPreferences.cmp",
            action: {
                openPreferences: {
                    cmp: {
                        location: "init." + (isLogged ? "logged" : "anonymous"),
                        stage: cookieBarMode.value,
                        expirationDays: cookieBarModeExpiration.value,
                        variant,
                    },
                },
            },
        });
    };

    // DL1.40
    const pushReditectToPrivacyPolicy = (isLogged: boolean) => {
        dataLayer.push({
            event: "action.openPrivacyPolicy.cmp",
            action: {
                openPrivacyPolicy: {
                    cmp: {
                        location: "init." + (isLogged ? "logged" : "anonymous"),
                        stage: cookieBarMode.value,
                        expirationDays: cookieBarModeExpiration.value,
                    },
                },
            },
        });
    };

    const pushThirdParty = () => {
        dataLayer.push({
            event: "action.view.cmp",
            action: {
                view: {
                    cmp: {
                        location: "thirdpartycontent",
                    },
                },
            },
        });
    };

    const pushThirdPartyConsent = () => {
        dataLayer.push({
            event: "action.grantConsent.cmp",
            action: {
                grantConsent: {
                    cmp: {
                        location: "thirdpartycontent",
                        purposeCodes: "thirdpartycontent",
                    },
                },
            },
        });
    };

    const pushOverlayRedirectToPreferenceCenter = (variant: "text" | "button") => {
        dataLayer.push({
            event: "action.openPreferences.cmp",
            action: {
                openPreferences: {
                    cmp: {
                        location: "thirdpartycontent",
                        variant,
                    },
                },
            },
        });
    };

    const pushOnlyNecessaryPurposesConsent = (purposeCodes: string, isLogged: boolean) => {
        dataLayer.push({
            event: "action.revokeConsent.cmp",
            action: {
                revokeConsent: {
                    cmp: {
                        location: "init." + (isLogged ? "logged" : "anonymous"),
                        stage: cookieBarMode.value,
                        expirationDays: cookieBarModeExpiration.value,
                        purposeCodes,
                    },
                },
            },
        });
    };

    function pushLinksClickConsentBar() {
        dataLayer.push({
            event: "action.show.promos",
            action: {
                show: {
                    promos: [
                        {
                            id: "cookieDisclaimer.othersActions",
                            name: "cookieDisclaimer",
                            position: "bottom",
                        },
                    ],
                },
            },
        });
    }

    return {
        pushViewCookieBarInitial,
        pushViewCookieBarRecheckAll,
        pushViewCookieBarRecheckSome,
        pushAllPurposesConsentClick,
        pushRedirectToPreferenceCenter,
        pushReditectToPrivacyPolicy,
        pushThirdParty,
        pushThirdPartyConsent,
        pushOverlayRedirectToPreferenceCenter,
        pushOnlyNecessaryPurposesConsent,
        pushLinksClickConsentBar,
    };
}
